import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { getSingle, updateSingle } from "../../services/photoService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import TableTitle from "../common/tableTitle";
import { Table } from "semantic-ui-react";
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

class PhotoEditForm extends Form {
  state = {
    
    imageUrl : "",
    data: {
      name: "",
    },
  
    errors: {}
  };

  schema = {
    name: Joi.string()
      .required()
      .label("Name"),
  };

  
  onChangeImage = e => {
    let files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    this.setState({ imageUrl: files[0] });
    //this.createImage(files[0]);
  };

  async populateAccount() {
    try {
      const accountId = this.props.match.params.id;

      this.setState({ blocking: true });
      const { data: account } = await getSingle(accountId);

      this.setState({ blocking: false });

      this.mapingImagesData(account);

      this.setState({
        imageUrl:account.image
      });

      this.setState({ data: this.mapToViewModel(account) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    await this.populateAccount();
  }

  mapingImagesData(account) {
    return {
      imageUrl: account.image
    };
  }

  mapToViewModel(account) {
    return {
      name: account.name,
    };
  }

  doSubmit = async () => {
    try {
      const ledgerTypeId = this.props.match.params.id;

      // const data = { ...this.state.data };
      // data.id = parseInt(ledgerTypeId);
      // this.setState({ blocking: true });

      // let event = new Date(this.state.preferredDate);
      // let date = JSON.stringify(event);
      // date = date.slice(1, 11);
     
      // data.preferred_tour_date = date;

      let formData = new FormData();
      formData.append("name", this.state.data.name);
      formData.append("image", this.state.imageUrl);
      
      formData.append("_method", "PUT");

      await updateSingle(formData, ledgerTypeId);
      this.setState({ blocking: false });
      toast.success("Photo has been updated successfully.");
      this.props.history.push("/web/photos");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

      
        this.setState({ errors, blocking: false });
        // toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/bank.png";
    const { editorState } = this.state;
    // if (auth.getCurrentUser().email != "company-unblocker@gondalgroup.ae") {
    //   return "Your are authorized to perform this action.";
    // }
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <TableTitle title="Update Photo" icon="tag" color="white" iconPath={dashboardIcon} />
        <center>
          <form
            onSubmit={this.handleSubmit}
            className="ui error form"
            style={{ width: "70%" }}
          >
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell colSpan="2">
                    Update Photo
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                
              
              <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                    {this.renderInput("name", "Name", "text")}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell width="16" colSpan="2">
                      <label>
                        Image
                      </label>
                      <input
                        className="input_imagem_artigo"
                        type="file"
                        onChange={this.onChangeImage}
                      />
                      <div className="imgPreview">
                        {this.state.imageUrl ? (
                          <img
                            className="add_imagem"
                            name="add_imagem"
                            height="40"
                            src={
                              process.env.REACT_APP_BACKEND_URL +
                              "/storage/" +
                              this.state.imageUrl
                            }
                          />
                        ) : (
                          ""
                        )}
                    </div>
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>
                    {this.renderButton("Update")}
                    <Link to="/web/photos" className="ui secondary button">
                      Back
                    </Link>
                  </Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </form>
        </center>
      </BlockUi>
    );
  }
}

export default PhotoEditForm;
